import React, { Component, PropTypes } from 'react';
import { ItemTypes } from '../constants';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { pointIcon } from '../reducers/point';

const pointSource = {
  beginDrag(props) {
    return {
      point: props.point,
    };
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});

const getStyles = ({ point, isDragging }) => {
  const left = point.coordinate.x / 100;
  const top = point.coordinate.y / 100;

  return {
    position: 'absolute',
    top: `${top}%`,
    left: `${left}%`,
    // IE fallback: hide the real node using CSS when dragging
    // because IE will ignore our custom "empty image" drag preview.
    opacity: isDragging ? 0 : 1,
    height: isDragging ? 0 : '',
  };
};

class ZonePointItem extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
      anchorX: 0,
      anchorY: 0,
    });
  }

  render() {
    const { point, connectDragSource, onDisplay } = this.props;

    const display = () => onDisplay(point);

    return connectDragSource(
      <div style={getStyles(this.props)} onClick={display}>
        <img src={pointIcon(point)} alt="Point" />
        <span>{point.number}</span>
      </div>
    );
  }
}

ZonePointItem.propTypes = {
  point: PropTypes.object.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  onDisplay: PropTypes.func.isRequired,
};

export default DragSource(ItemTypes.POINT, pointSource, collect)(ZonePointItem);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/ZonePointItem.js